import styled from "styled-components";
import {default as BaseScreenContainer} from '../../components/screen-container';

export const ScreenContainer = styled(BaseScreenContainer)`
    
`;